export enum WistiaVideoId {
  DASHBOARD_ANNOUNCEMENT_TEXT = 'w3xxhi7xiv',
  PRO_FEATURES = 'g3n7zvfdfa',
  PREMIUM_FEATURES = 'xpuuqea34o',
  ONBOARDING_SUCCESS = 'b9wjyus86q'
}